import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Bấm thông báo đẩy khi ERP đang mở: service worker gửi { type: 'NAVIGATE', url } → đổi màn trong app (X-PWA bước 3). */
export function useSwNavigate() {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    const onMsg = (e: MessageEvent) => {
      const d = e.data as { type?: string; url?: string } | null;
      if (d?.type !== 'NAVIGATE' || typeof d.url !== 'string') return;
      const u = new URL(d.url, window.location.origin);
      if (u.origin === window.location.origin) navigate(u.pathname + u.search + u.hash);
    };
    navigator.serviceWorker.addEventListener('message', onMsg);
    return () => navigator.serviceWorker.removeEventListener('message', onMsg);
  }, [navigate]);
}
